import React from 'react';

import { FormattedMessage } from 'react-intl';

import * as styles from 'src/sections/global/components/page.style';

import messages from './activity-panel.i18n';

/**
 * Renders the header component for the activity panel on the pull request overview tab.
 *
 * @returns The rendered activity panel header component.
 */

export const ActivityPanelTitle = () => {
  return (
    <styles.PanelHeader>
      <FormattedMessage {...messages.activityPanelLabel} />
    </styles.PanelHeader>
  );
};
